import React, { useMemo } from 'react';
import './HelpTemplate.css';
import HelpIndicator from '../../HelpIndicator/HelpIndicator';
import HelpLink from '../HelpLink/HelpLink';
import HelpModal from '../HelpModal/HelpModal';
import en from './locales/HelpTemplate.en.json';
import compose from '../../utils/compose';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import { injectIntl } from 'react-intl';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import { formatI18n } from '../../I18n/I18n/I18n';
var INTL_BASE = '@dm/components.help-template';
var MAX_CHARACTERS_FOR_INDICATOR = 140;
var messages = normalizeLocaleData(en, INTL_BASE);
var stripHTML = function stripHTML(html) {
  var tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return (tmp.textContent || '').trim();
};
var SingleHelpTemplate = compose(withAdditionalIntl(messages), injectIntl)(function (_ref) {
  var description = _ref.description,
    intl = _ref.intl,
    i18n = _ref.i18n;
  var desc = description || {};
  var textLabel = stripHTML(formatI18n(intl, i18n));
  var ariaKey = textLabel ? desc.href ? 'link-to' : 'show-help' : 'default-help';
  var label = useMemo(function () {
    return {
      id: "".concat(INTL_BASE, ".").concat(ariaKey),
      values: {
        label: textLabel
      }
    };
  }, [ariaKey, textLabel]);
  var title = useMemo(function () {
    return formatI18n(intl, {
      id: "".concat(INTL_BASE, ".modal-title"),
      values: {
        label: textLabel
      }
    });
  }, [textLabel]);
  if (desc.href) {
    return /*#__PURE__*/React.createElement(HelpLink, {
      to: desc.href,
      label: label
    });
  }
  var text = desc.i18n ? formatI18n(intl, desc.i18n) : '';
  var modal = desc.escape === false || text.length > MAX_CHARACTERS_FOR_INDICATOR;
  var Component = modal ? HelpModal : HelpIndicator;
  return desc.i18n ? /*#__PURE__*/React.createElement(Component, {
    i18n: desc.i18n,
    escape: desc.escape === true,
    title: title,
    label: label
  }) : '';
});
function toI18n(text) {
  return {
    i18n: {
      id: text
    },
    escape: true
  };
}
export default function HelpTemplate(_ref2) {
  var description = _ref2.description,
    i18n = _ref2.i18n;
  if (description) {
    var descriptions = Array.isArray(description) ? description : [description];
    return /*#__PURE__*/React.createElement(React.Fragment, null, descriptions.map(function (value, index) {
      var description = typeof value === 'string' ? toI18n(value) : value;
      return /*#__PURE__*/React.createElement(SingleHelpTemplate
      // @todo key should be something stable
      , {
        key: index,
        description: description,
        i18n: i18n
      });
    }));
  } else {
    return null;
  }
}